<script>
import { mapActions } from 'vuex';

import TableView from '@/components/elements/views/TableView';
import AddManagersModal from '@/components/forums/AddManagersModal';

export default {
    components: {
        AddManagersModal
    },

    extends: TableView,

    props: {
        forumId: {
            type: String,
            required: false,
            default: ''
        }
    },

    data() {
        return {
            includeHeader: false
        };
    },

    computed: {
        additionalFetchData() {
            return {
                forumId: this.forumId
            };
        },
        options() {
            return {
                addButtonText: 'Add new manager',
                clickableRows: false
            };
        },
        confirmationModalContent() {
            return `Are you sure you want to unassign this manager?`;
        },

        labels() {
            return [
                {
                    value: 'fullName',
                    width: '150px'
                },
                {
                    value: 'info',
                    width: '150px'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                },
                {
                    value: 'updatedAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        },

        additionalComponents() {
            const addManagersModalComponent = {
                name: 'add-managers-modal',
                props: {
                    forumId: this.forumId
                },
                events: {
                    'managers-assigned': this.onRefresh
                }
            };

            return [addManagersModalComponent];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'forums/getForumManagers',
            deleteItem: 'forums/unassignManagers'
        }),

        setupDeleteData(idToDelete) {
            return {
                forumId: this.forumId,
                userId: idToDelete
            };
        },

        onAddButtonClick() {
            this.$bvModal.show('add-managers-modal');
        },

        getDeleteMessage() {
            return `Manager has been unassigned.`;
        }
    }
};
</script>
